module.exports = __webpack_public_path__ + "static/media/aucardholder.64140923.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aucardholder.png
// module id = 333
// module chunks = 1